import dayjs from 'dayjs';
import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_KEY, RozsahDate } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ProvozovnaId: [],
		ZakazkaDruh: [],
		SmVariaZkt: [],
		DoklpolozPzn: [],
		EmisePzn: [],
		VyrobekvozOzn: [],
		SkladOzn: [],
		PlatbaPzn: [],
		DokladDruh: [],
		PracovnikOzn: [],
		PujcovnaId: [],
	},
	filter: {
		PorovnaniCj: false,
		ProvozovnaId: null as number | null,
		ZakazkaDruh: null as number | null,
		DetailTisk: false,
		SmVariaZkt: [],
		AndOr: false,
		PracovnikId: null as number | null,
		DatOd: null as Date | null,
		DatDo: null as Date | null,
		RozsahDate: RozsahDate.casLibObdobi,
		Vyhodnoceni: true,
		OhodnoteniVykonu: true,
		VypocetSlevy: true,
		ZakazkaNr: null as number | null,
		ZakaznikId: null as number | null,
		ZakaznikIdText: null as string | null,
		ZobrazovatCisloZak: false,
		PolozkaNr: null as string | null,
		PolozkaNrPodretezec: false,
		PolozkaText: null as string | null,
		PolozkaTextPodretezec: false,
		PojistovnaId: null as number | null,
		PojistovnaIdText: null as string | null,
		PoistovnaPrp: null as boolean | null,
		LeaszakaznikId: null as number | null,
		LeaszakaznikIdText: null as string | null,
		LeasingPrp: null as boolean | null,
		DoklpolozPzn: null as number | null,
		EmisePzn: null as number | null,
		VyrobekvozOzn: null as string | null,
		TiskSasPrp: false,
		SkladOzn: null as string | null,
		PlatbaPzn: null as number | null,
		DokladDruh: null as string | null,
		ZobrazZak: true,
		Kosv: false,
		Reka: true,
		PracovnikOzn: null as number | null,
		IsElsaBC: false,
		TiskOsobCis: false,
		TiskIndetifCis: true,
		PujcovnaId: null as number | null,
		VozidlopaId: null as number | null,
	},
	tableSetting: {},
	localState: {
		accessFlags: 0,
		PracovnikIdText: null as string | null,
		PracovnikOsobniCis: null as string | null,
		AndOrList: [] as { Text: string, Value: Boolean }[],
		RozsahDateList: [] as { Text: string, Value: RozsahDate }[],
		VyhodnoceniList: [] as { Text: string, Value: Boolean }[],
		OhodnoteniVykonuList: [] as { Text: string, Value: Boolean }[],
		VypocetSlevyList: [] as { Text: string, Value: Boolean }[],
		ElsaBC: [] as { Text: string, Value: Boolean }[],
		VozidlopaSpz: null as string | null,
		VozidlopaKaroserieNr: null as string | null,
		VlastniVoz: true,
		ExterniVoz: true,
	},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[editMutations.POJISTOVNA_SELECT_MAPPER](state, { data }: any) {
			state.filter.PoistovnaPrp = !!data.value;
			state.filter.PojistovnaId = data.value;
			state.filter.PojistovnaIdText = data.text;
		},
		[editMutations.LEASING_SELECT_MAPPER](state, { data }: any) {
			state.filter.LeasingPrp = !!data.value;
			state.filter.LeaszakaznikId = data.value;
			state.filter.LeaszakaznikIdText = data.text;
		},
		[editMutations.ZAKAZNIK_SELECT_MAPPER](state, { data }) {
			state.filter.ZakaznikId = data.value;
			state.filter.ZakaznikIdText = data.text;
		},
		[editMutations.PRACOVNIK_SELECT_MAPPER](state, { data }) {
			state.filter.PracovnikId = data.value;
			state.localState.PracovnikIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.localState.PracovnikOsobniCis = data.osobniCis;
		},
		[editMutations.VOZIDLO_PUJCOVNA_SELECT_MAPPER](state, { data }) {
			state.filter.VozidlopaId = data.value;
			state.localState.VozidlopaSpz = data.VozidlopaSpz;
			state.localState.VozidlopaKaroserieNr = data.VozidlopaKaroserieNr;
		},
		setRozsahDate(state, rozsah: RozsahDate) {
			state.filter.RozsahDate = rozsah;
			const start = dayjs().startOf('day');
			const kvartal = (start.month() - 1) / 3;

			switch (rozsah) {
				case RozsahDate.casDnes:
					state.filter.DatOd = start.toDate();
					state.filter.DatDo = dayjs().toDate();
					break;
				case RozsahDate.casVcera:
					state.filter.DatOd = start.add(-1, 'day').toDate();
					state.filter.DatDo = dayjs(state.filter.DatOd).endOf('day').toDate();
					break;
				case RozsahDate.casTentoMesic:
					state.filter.DatOd = start.startOf('month').toDate();
					state.filter.DatDo = dayjs().toDate();
					break;
				case RozsahDate.casMinulyMesic:
					state.filter.DatOd = start.startOf('month').add(-1, 'month').toDate();
					state.filter.DatDo = dayjs(state.filter.DatOd).endOf('month').toDate();
					break;
				case RozsahDate.casTentoRok:
					state.filter.DatOd = start.startOf('year').toDate();
					state.filter.DatDo = dayjs().toDate();
					break;
				case RozsahDate.casMinulyRok:
					state.filter.DatOd = start.startOf('year').add(-1, 'year').toDate();
					state.filter.DatDo = dayjs(state.filter.DatOd).endOf('year').toDate();
					break;
				case RozsahDate.casMinulyKvart:
					state.filter.DatOd = start.startOf('year').add(((kvartal - 1) * 3), 'month').toDate();
					state.filter.DatDo = dayjs(state.filter.DatOd).add(2, 'month').endOf('month').endOf('day')
						.toDate();
					break;
				default:
			}
		},
	},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => { },
	},
});
